import React, {useEffect, useRef, useState} from "react";
import {Document, Page, pdfjs} from "react-pdf";
import {Container} from "./PDFPreviewFirstPage.styled";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface PDFPreviewFirstPageProps {
  pdfUrl: string;
}

const PDFPreviewFirstPage: React.FC<PDFPreviewFirstPageProps> = ({pdfUrl}) => {
  const [parentWidth, setParentWidth] = useState<number | null>(null);
  const [pdfBlob, setPdfBlob] = useState<ArrayBuffer | string | null>(null);
  const parentRef = useRef<HTMLDivElement>(null);

  const getIOSVersion = (): number | null => {
    const match = navigator.userAgent.match(/OS (\d+)_/);
    return match ? parseInt(match[1], 10) : null;
  };

  const iOSVersion = getIOSVersion();
  const isOldIOS = iOSVersion && iOSVersion < 17;

  useEffect(() => {
    const handleResize = () => {
      if (parentRef.current) {
        setParentWidth(parentRef.current.clientWidth);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (isOldIOS) {
      fetch(pdfUrl, {cache: "no-store"})
        .then((res) => res.arrayBuffer())
        .then((buffer) => {
          setPdfBlob(buffer);
        })
        .catch((error) => console.error("Error loading PDF:", error));
    } else {
      setPdfBlob(pdfUrl);
    }
  }, [pdfUrl]);

  return (
    <Container ref={parentRef}>
      {!isOldIOS && parentWidth && parentWidth ? (
        <Document
          file={pdfUrl}
          loading="Loading PDF..."
        >
          <Page
            width={parentWidth}
            pageNumber={1}
          />
        </Document>
      ) : (
        isOldIOS &&
        parentWidth && (
          <Document
            file={pdfBlob}
            loading="Loading PDF..."
          >
            <Page
              width={parentWidth}
              pageNumber={1}
            />
          </Document>
        )
      )}
    </Container>
  );
};

export default PDFPreviewFirstPage;
